module.exports = __webpack_public_path__ + "static/media/views-icon.8cf881d5.svg";